import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { UserPermission } from '@adornis/users/db/types.js';
import { assertUserFromContext } from '@adornis/users/server/util.js';
import { Teacher } from '../teacher.js';

export const getAllTeachersQuery: ReturnType<typeof registerQuery> = registerQuery({
  operationName: 'getAllTeachers',
  type: () => [Teacher],
  params: [],
  resolve: () => async () => {
    const user = await assertUserFromContext();
    if (!user.hasPermission(UserPermission.Impersonate)) {
      throw new Error('Access denied');
    }
    const col = await getRawCollection(Teacher._collectionName);
    // Exclude other admins to prevent privilege escalation via impersonation
    return col.find({ isAdmin: { $ne: true } }).toArray();
  },
});
